import { useEffect, useState } from 'react';
import PortalMergeModal from 'components/PortalMergeModal';
import { setBannerAsSeen } from 'data/api';
import { jsx as _jsx } from "react/jsx-runtime";

const PortalMergeUncontrolledModal = _ref => {
  let {
    banner,
    screen,
    seenBannerType
  } = _ref;
  const {
    0: show,
    1: setShow
  } = useState(true);
  useEffect(() => {
    setBannerAsSeen({
      type: seenBannerType
    });
  }, [seenBannerType]);

  function handleClose() {
    setShow(false);
  }

  return /*#__PURE__*/_jsx(PortalMergeModal, {
    show: show,
    banner: banner,
    screen: screen,
    onClose: handleClose
  });
};

export default PortalMergeUncontrolledModal;